import {
  SENS_ACHAT, MODULE_ACHAT, SOUS_TYPE_NORMAL,
  TYPE_COMMANDE, COMMANDE_ACHAT_FOURNISSEUR_ETAT, ETAT_SANSSUITE,
} from '@/configuration/devisConf';
import { TYPE_REFERENCE_EXTERNE_VENTE } from '@/configuration/dcf/dcfConf';

export default function genererCritereRechercheLigneCommande() {
  return {
    libelleProduit: null,
    libelle: null,
    auto: '',
    referenceProduit: null,
    villes: [],
    tiersId: [],
    produitsIds: [],
    societeId: null,
    code: null,
    typeReferenceExterne: TYPE_REFERENCE_EXTERNE_VENTE,
    sens: SENS_ACHAT,
    typesDevisCommandeFacture: [TYPE_COMMANDE],
    etatsDevisCommandeFacture: COMMANDE_ACHAT_FOURNISSEUR_ETAT
      .filter(e => e.code !== ETAT_SANSSUITE)
      .map(e => e.code),
    sousTypes: [SOUS_TYPE_NORMAL],
    module: MODULE_ACHAT,
    types: [SOUS_TYPE_NORMAL],
    referenceExterne: null,
  };
}
